<template>
    <div id="AssetSale">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div v-if="assetId != undefined">
            <data-table-filter-config :moduleName="'CapitalCostAnalysisList'" ref="filterContractAsset" @cancelSelection="cancelAll" :allowSameFilter="'allow'">
            </data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange" :moduleName="'CapitalCostAnalysisList'" :position="'top'">
                        </custom-pagination>
                        <vue-good-table
                            ref="listCapitalCostAnalysis"
                            mode="remote"
                            title="Capital Cost Analysis List"
                            @on-page-change="onPageChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            @on-select-all="onSelectAll"
                            :totalRows="totalRecords"
                            :columns="userColumns"
                            :rows="rows"
                            :pagination-options="{
                                enabled: false,
                                position: 'both',
                                perPage: perPage,
                                perPageDropdown:dropDownPerPage,
                                dropdownAllowAll: false,
                            }"
                            :select-options="{
                            enabled: contract_asset_detail_value,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                            }"
                            :search-options="{
                            enabled: false,
                            }">
                        </vue-good-table>
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                        </custom-pagination>
                </section>
            </div>
        </div>
        <div v-else id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Capital Cost Analysis List</div>
                        <div class="btn-groups text-right">
                            <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                                <i class="fp-export"></i> Export
                            </a>
                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-sale-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'CapitalCostAnalysisList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'CapitalCostAnalysisList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listCapitalCostAnalysis"
                                      mode="remote"
                                      title="Capital Cost Analysis List"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-select-all="onSelectAll"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: true,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      >
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import moment from 'moment';


    export default {
        name: "CapitalCostAnalysisList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Capital Cost Analysis List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetId: {
                type: Number,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            pageKey: "_capital_cost_analysis_list_",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: '#Unit',
                    field: 'unit_no',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'vehicle_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sequence',
                    field: 'sequence',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sequence", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Month',
                    field: 'month',
                    fpFieldType:"text",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Month", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Year',
                    field: 'year',
                    fpFieldType:"text",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Module Name',
                    field: 'module_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Module Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Transaction Type',
                    field: 'trans_type',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Transaction Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Transaction Type Desc',
                    field: 'trans_type_desc',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Transaction Type Desc", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Transaction Date',
                    field: 'transaction_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Transaction Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Capital Cost',
                    field: 'capital_amount',
                    filterable: true,
                    hidden:false,
                    type:'number',
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Capital Cost", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Current Capital Cost',
                    field: 'current_cap_cost',
                    filterable: true,
                    hidden:false,
                    type:'number',
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Current Capital Cost", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: "VIN",
                    field: "vin_no",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                    enabled: false,
                    placeholder: "VIN No.",
                    filterValue: "",
                    trigger: "enter"
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'transaction_date',
                    type: 'desc',
                },
                page: 1,
                perPage: 10
            },
            loading:false,
            selectedFile:"",
            error:"",
            action:'list',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            batchProcess:0,
            batchNum:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_capital_cost') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },

        mounted: function() {
            var self = this;
            //self.loadList();

            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();
            // this.loadFieldData(['depriciation_type']);

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listCapitalCostAnalysis.unselectAllInternal();
            },
            exportCheck: function() {
              var count = 0;
              var actionFlag = "";
              var data = this.$refs['listCapitalCostAnalysis'].selectedRows;
              count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
              this.exportReports(actionFlag);
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                 var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listCapitalCostAnalysis'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listCapitalCostAnalysis'].selectedRows[i].id)
                }
                var assetId = '';
                if (self.assetId != undefined){
                    assetId = self.assetId;
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action: self.action,
                    selectedRows:selectedRows,
                    vehicle_id:assetId,
                    selectedAll:self.serverParams.selectedAll
                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/capital-cost-analysis/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {
                                  if ( self.action == "export" ) {
                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";
                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);
                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }
                              }
                              self.action = "list";
                              self.loadList();

                            } else {

                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;

                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'capital-cost-analysis-list')

                    }
                });
            },
        },

    };
</script>
<style scoped>
.custom-margin{
    margin-left:5px !important;
}
.custom-margin-top{
    margin-top:5px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/asset/CapitalCostAnalysisList.vue